import React, { useEffect } from 'react';
import Image from '../../refresh/atoms/ImageView';
import properties from '../../modules/ajio-util/properties';
import { gtmEventPush } from '../../modules/ga/GTMdatalayer';
import Divider from '../../refresh/atoms/Divider';

const imgPath = `${properties.getProperty('imageBaseUrl')}/static/img`;

interface AssuredGiftsWidgetProps {
  assuredConstants: {
    giftBoxText: string;
    detailsSentPayment: string;
  };
  value: number;
}

const AssuredGiftsWidget = (props: AssuredGiftsWidgetProps): JSX.Element => {
  const { assuredConstants: { giftBoxText = '', detailsSentPayment = '' } = {}, value = 0 } = props;

  useEffect(() => {
    gtmEventPush({
      event: 'widget interaction',
      event_category: 'widget interaction',
      event_action: 'free gift widget view',
      amount_payable: value
    });
  }, []);

  return (
    <div>
      <Divider className="assured-gifts-divider" />
      <div className="assured-gifts-container">
        <Image
          src={`${imgPath}/assured-gift-box.svg`}
          alt="Gift icon"
          className="assured-gifts-gift-image"
        />
        <div className="assured-gifts-text-container">
          <p>{giftBoxText}</p>
          <p>{detailsSentPayment}</p>
        </div>
      </div>
    </div>
  );
};

export default AssuredGiftsWidget;
